<template>
  <div class="w-full min-w-xl lg:min-w-0 pr-6 lg:pr-0">
    <div class="flex items-baseline">
      <div class="w-64 flex-no-shrink py-2 px-4 whitespace-no-wrap">
        <h2 class="text-base whitespace-no-wrap">
          Progress Report
        </h2>
      </div>
      <div class="w-full flex justify-end">
        <div
          v-for="(interval, index) in intervals"
          :key="interval.id"
          class="text-center text-sm"
          :style="widthCalc(interval)"
          :class="{
            'hidden' : !interval.requires_monitor_feedback,
            'font-bold': interval.requires_claim_review || (incomplete && interval.partner_can_provide_feedback && canEdit),
            'text-positive-700': interval.partner_can_provide_feedback && !incomplete && canEdit,
            'text-neutral-700': interval.partner_can_provide_feedback && incomplete && canEdit,
            'text-grey-500': index > activeIndex
          }"
        >
          <template v-if="interval.requires_monitor_feedback">
            <span
              class="inline-block"
              style="transform: rotate(-56.25deg); transform-origin:25% 0;"
            >
              {{ interval.date }}
              <icon
                v-if="interval.partner_can_provide_feedback && canEdit"
                :icon="incomplete ? 'important' : 'check'"
                class="w-3 h-3 align-middle"
                :class="{
                  'icons-neutral': incomplete,
                  'icons-positive': !incomplete
                }"
              />
            </span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressReportHeader",
  props: {
    canEdit: {
      type: Boolean,
      default: false
    },
    incomplete: {
      type: Boolean,
      default: false
    },
    intervals: {
      type: Array,
      required: true
    }
  },
  computed: {
    activeIndex() {
      return this.intervals.findIndex(
        interval => interval.partner_can_provide_feedback
      );
    }
  },
  methods: {
    widthCalc(interval) {
      const items = [true, interval.requires_monitor_feedback, interval.requires_msp_feedback].filter(Boolean);
      return {
        width: `${items.length * 3}.25rem`
      };
    }
  }
};
</script>
